import type { CustomFlowbiteTheme } from 'flowbite-react';

export const tooltipTheme: CustomFlowbiteTheme['tooltip'] = {
  target: 'w-fit',
  animation: 'transition-opacity',
  arrow: {
    base: 'absolute z-10 h-2 w-2 rotate-45',
    style: {
      dark: 'bg-titan-night-900',
      light: 'bg-white',
      auto: 'bg-white',
    },
    placement: '-4px',
  },
  base: 'absolute z-10 inline-block rounded-lg px-3 py-2 text-sm font-medium shadow-sm',
  hidden: 'invisible opacity-0',
  style: {
    dark: 'bg-titan-night-900 text-white',
    light: 'border border-titan-night-200 bg-white text-titan-night-900',
    auto: 'border border-titan-night-200 bg-white text-titan-night-900',
  },
  content: 'relative z-20',
};
